import dayjs from 'dayjs';
import { DocumentCategory } from './enums/document-category.enum';

export interface IDocument {
  id?: number;
  token?: string | null;
  category?: DocumentCategory | null;
  fileName?: string | null;
  creationDate?: dayjs.Dayjs | null;
  link?: string | null;
  relationId?: number | null;
}

export class Document implements IDocument {
  constructor(
    public id?: number,
    public token?: string | null,
    public category?: DocumentCategory | null,
    public fileName?: string | null,
    public creationDate?: dayjs.Dayjs | null,
    public link?: string | null,
    public relationId?: number | null
  ) {}
}

export function getDocumentIdentifier(document: IDocument): number | undefined {
  return document.id;
}
